import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

document.addEventListener('DOMContentLoaded', function () {
  const galleryContainer = document.querySelector('.js-pdf-preview');

  if (!galleryContainer) {
    return;
  }

  const galleryInstance = lightGallery(galleryContainer, {
    selector: 'img',
    plugins: [lgZoom, lgThumbnail],
    mode: 'lg-slide-vertical',
    speed: 300,
    thumbnail: false,
    mousewheel: true,
    addClass: 'ebook-preview',
    loop: false,
    hideControlOnEnd: true,
  });

  document
    .querySelector('.js-pdf-preview-button')
    ?.addEventListener('click', (e) => {
      e.preventDefault();
      galleryInstance.openGallery(0); // otvorí prvý obrázok
    });
});
